import { render, staticRenderFns } from "./ModalSelectPartiteDenunce.vue?vue&type=template&id=6c3d255f"
import script from "./ModalSelectPartiteDenunce.vue?vue&type=script&lang=js"
export * from "./ModalSelectPartiteDenunce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports